// Asegúrate de que el objeto Shopify exista y tenga la función formatMoney.
if (typeof Shopify === 'undefined') {
  Shopify = {};
}
// Si Shopify.formatMoney no está definida, la definimos.
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents === 'string') { cents = cents.replace('.', ''); }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || window.Shopify?.money_format || '${{ amount }}';

    function defaultOption(opt, def) { return (typeof opt === 'undefined' ? def : opt); }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number === null) { return 0; }
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }

    const formatTypeMatch = formatString.match(placeholderRegex);
    if (formatTypeMatch && formatTypeMatch[1]) {
        switch (formatTypeMatch[1]) {
            case 'amount': value = formatWithDelimiters(cents, 2); break;
            case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
            case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
            case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
            default: value = formatWithDelimiters(cents, 2);
        }
    } else { value = formatWithDelimiters(cents, 2); }
    return formatString.replace(placeholderRegex, value);
  };
}
// Asegúrate de que el formato de dinero de la tienda esté disponible.
if (typeof Shopify.money_format === 'undefined') {
  Shopify.money_format = '${{ amount }}';
}


document.addEventListener('DOMContentLoaded', () => {
  const sideCart = document.getElementById('side-cart');
  const cartContent = document.getElementById('side-cart-items');
  const cartSubtotal = document.getElementById('side-cart-subtotal-price');
  const cartCountBubble = document.querySelector('.cart-count-bubble');

  if (!sideCart || !cartContent || !cartSubtotal) {
    return;
  }

  // --- Funciones del Carrito Lateral ---

  const FOCUSABLE = 'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])';

  const trapFocus = (container) => {
    const elements = container.querySelectorAll(FOCUSABLE);
    const first = elements[0];
    const last = elements[elements.length - 1];
    const handler = (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    container.addEventListener('keydown', handler);
    if (first) first.focus();
    return () => container.removeEventListener('keydown', handler);
  };

  let removeTrap = null;

  // Función para abrir el carrito lateral (AHORA GLOBAL)
  window.openCart = () => {
    // Primero, asegurar que el contenido esté actualizado
    updateCartView().then(() => {
        sideCart.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        removeTrap = trapFocus(sideCart);
    }).catch(error => {
        // Aún así intentar abrirlo
        sideCart.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        removeTrap = trapFocus(sideCart);
    });
  };

  // Función para cerrar el carrito lateral (Local)
  const closeCart = () => {
    sideCart.classList.remove('is-open');
    document.body.style.overflow = '';
    if (removeTrap) { removeTrap(); removeTrap = null; }
  };

  // Función asíncrona para actualizar el contenido y los totales (Local)
  const updateCartView = async () => {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const cart = await res.json();

      cartContent.innerHTML = ''; // Limpiar

      if (cart.item_count === 0) {
        cartContent.innerHTML = '<p style="text-align: center; padding: 20px;">Tu carrito está vacío.</p>'; // Mensaje centrado
      } else {
        cart.items.forEach(item => {
          // Generar HTML del item (simplificado para ejemplo)
          const itemHTML = `
            <div class="cart-item" data-cart-item-key="${item.key}">
              <img src="${item.image || '//cdn.shopify.com/s/files/1/0shopify/common/no-image-100x100.png'}" alt="${item.product_title || ''}" class="cart-item__image">
              <div class="cart-item__details">
                <p class="cart-item__title">${item.product_title || 'Producto'}</p>
                ${item.variant_title ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
                <p class="cart-item__quantity">Cantidad: ${item.quantity}</p>
                 <p class="cart-item__price">${Shopify.formatMoney(item.final_line_price, Shopify.money_format)}</p>
                 </div>
                 </div>
                 `;
                 // <button class="cart-item__remove" data-item-key="${item.key}">Eliminar</button> // Opcional: Botón eliminar
          cartContent.innerHTML += itemHTML;
        });
         // Opcional: Añadir listeners para botones de eliminar si los agregaste
         // addRemoveListeners();
      }

      cartSubtotal.innerHTML = Shopify.formatMoney(cart.total_price, Shopify.money_format);

      if (cartCountBubble) {
        cartCountBubble.textContent = cart.item_count;
        cartCountBubble.style.display = cart.item_count > 0 ? 'flex' : 'none'; // Asegura visibilidad
      }

    } catch (error) {
      cartContent.innerHTML = '<p style="color: red; text-align: center; padding: 20px;">Error al cargar el carrito.</p>';
    }
  };


  // --- Event Listeners para Abrir/Cerrar ---

  // Asigna eventos para cerrar
  const overlay = sideCart.querySelector('.side-cart__overlay');
  const closeButton = sideCart.querySelector('.side-cart__close-btn');
  if (overlay) overlay.addEventListener('click', closeCart);
  if (closeButton) closeButton.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => e.key === 'Escape' && sideCart.classList.contains('is-open') && closeCart());

  // Permite abrir el carrito desde el icono del header
  // **Asegúrate que el selector '.header-cart-trigger' sea correcto para tu icono**
  const headerCartIcon = document.querySelector('.header-cart-trigger, a[href="/cart"], #cart-icon-bubble'); // Añadir selectores comunes
  if (headerCartIcon) {
      headerCartIcon.addEventListener('click', (e) => {
          // Prevenir navegación solo si NO es el enlace principal a /cart
          // Si tu icono está dentro de un <a> a /cart, podrías querer permitir la navegación
          // si el usuario hace clic derecho o ctrl+clic.
          if (!e.metaKey && !e.ctrlKey) {
             e.preventDefault();
             window.openCart(); // Llama a la función global para abrir (que también actualiza)
          }
      });
  } else {
  }

  /* // Listener de submit global COMENTADO/ELIMINADO para evitar conflicto
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      // ... este código ya no se necesita aquí ...
    });
  });
  */

  // Actualiza la vista del carrito al cargar la página (sin abrirlo)
  // Esto asegura que el contador y subtotal iniciales sean correctos.
  updateCartView();

}); // Fin DOMContentLoaded